import React, { useState } from "react";
import MasterLayout from "../otherImages/MasterLayout";
import DefaultTopBar from "../components/DefaultTopBar";
import EmailTemplateForm from "../components/EmailTemplateForm";
import EmailTemplatesList from "../components/EmailTemplatesList";

const EmailTemplatesPage = () => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  React.useEffect(() => {
    const showList = () => setSelectedTemplate(null);

    window.addEventListener("emailTemplates:showList", showList);
    return () => window.removeEventListener("emailTemplates:showList", showList);
  }, []);

  return (
    <>
      <MasterLayout>
        <DefaultTopBar title={selectedTemplate?.name || "Email Templates"} />
        {selectedTemplate ? (
          <EmailTemplateForm
            template={selectedTemplate}
            onBack={() => setSelectedTemplate(null)}
          />
        ) : (
          <EmailTemplatesList onEdit={setSelectedTemplate} />
        )}
      </MasterLayout>
    </>
  );
};

export default EmailTemplatesPage;
